import * as HttpService from './HttpService'

let namespace = ''

let accounts = (params, cb, errorCb) => {
    HttpService.get(namespace + 'accounts', params, cb, errorCb)
}

let accountPlan = (params, cb, errorCb) => {
    HttpService.get(namespace + 'accounts/plan', params, cb, errorCb)
}

let accountCategories = (params, cb, errorCb) => {
    HttpService.get(namespace + 'account-categories', params, cb, errorCb)
}

let updateAccount = (uuid, body, params, cb, errorCb) => {
    HttpService.put(namespace + 'accounts/' + uuid, body, params, cb, errorCb)
}

let revenueAndCosts = (params, cb, errorCb) => {
    HttpService.get(namespace + 'calculations/economy/revenueandcosts', params, cb, errorCb)
}

let materialUsage = (params, cb, errorCb) => {
    HttpService.get(namespace + 'calculations/economy/material-usage', params, cb, errorCb)
}

let suppliers = (params, cb, errorCb) => {
    HttpService.get(namespace + 'calculations/economy/suppliers', params, cb, errorCb)
}

let costpricePerHour = (params, cb, errorCb) => {
    HttpService.get(namespace + 'calculations/economy/costprice-per-hour', params, cb, errorCb)
}

let costsDivision = (params, cb, errorCb) => {
    HttpService.get(namespace + 'calculations/economy/costs-division', params, cb, errorCb)
}

let keyFigures = (params, cb, errorCb) => {
    HttpService.get(namespace + 'calculations/economy', params, cb, errorCb)
}
let accountingYearsCheck = (params, cb, errorCb) => {
    HttpService.get(namespace + 'accounting-years-check', params, cb, errorCb)
}

let compareKeyfigures = (params, cb, errorCb) => {
    HttpService.get(namespace + 'calculations/compare-keyfigures', params, cb, errorCb)
}

let compareRevenue = (params, cb, errorCb) => {
    HttpService.get(namespace + 'calculations/compare-revenue', params, cb, errorCb)
}

let compareCoveragePercent = (params, cb, errorCb) => {
    HttpService.get(namespace + 'calculations/compare-coverage-percent', params, cb, errorCb)
}

let compareCoverage = (params, cb, errorCb) => {
    HttpService.get(namespace + 'calculations/compare-coverage', params, cb, errorCb)
}

let compareCoveragePerHour = (params, cb, errorCb) => {
    HttpService.get(namespace + 'calculations/compare-coverage-per-hour', params, cb, errorCb)
}

let compareCustomerHours = (params, cb, errorCb) => {
    HttpService.get(namespace + 'calculations/compare-customer-hours', params, cb, errorCb)
}

export {
    accounts,
    updateAccount,
    accountPlan,
    accountCategories,
    revenueAndCosts,
    materialUsage,
    suppliers,
    costpricePerHour,
    costsDivision,
    keyFigures,
    accountingYearsCheck,
    compareKeyfigures,
    compareRevenue,
    compareCoveragePercent,
    compareCoverage,
    compareCoveragePerHour,
    compareCustomerHours
}



// WEBPACK FOOTER //
// ./src/services/economyService.js